import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import MiniPOSDashboard from '@/components/dashboard/MiniPOSDashboard';

export default function DashboardPage() {
  const { user, logout } = useAuth();

  if (!user) {
    // This should ideally not happen if AuthGuard is working correctly,
    // but as a fallback, redirect or show an error.
    return <p>Loading user data or not authenticated...</p>;
  }

  return (
    <MiniPOSDashboard />

  );
}
